import React, { useState, useEffect } from 'react';
import ShopProductGrid from '../components/ShopProductGrid';
import ProductDetailModal from '../components/ProductDetailModal';
import { db } from '../firebase';
import { collection, onSnapshot, query, orderBy, getDocs } from "firebase/firestore";

const ShopPage = ({ onAddToCart }) => {
  const [products, setProducts] = useState([]);
const [categories, setCategories] = useState([{ id: 'all', name: 'Todas' }]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    useEffect(() => {
  async function fetchCategories() {
    const cats = [{ id: 'all', name: 'Todas' }];
const querySnapshot = await getDocs(collection(db, "categorias"));
    querySnapshot.forEach((doc) => {
      cats.push({ id: doc.id, ...doc.data() });
    });
    setCategories(cats);
    console.log('CATEGORIAS DESDE FIREBASE', cats);
  }
  fetchCategories();
}, []);


  // Carga los productos desde Firestore en tiempo real
  useEffect(() => {
    const q = query(collection(db, "productos"), orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setProducts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubscribe();
  }, []);

  // Filtro igual que antes pero usando productos de Firebase
  const filteredProducts = products.filter((product) => {
    const matchesSearch =
      product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.description.toLowerCase().includes(searchTerm.toLowerCase());
const matchesCategory =
  selectedCategory === 'all' ||
  selectedCategory === 'Todas' ||
  product.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const handleViewDetail = (product) => {
    setSelectedProduct(product);
    setIsDetailModalOpen(true);
  };

  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false);
    setSelectedProduct(null);
  };

  return (
    <div className="bg-background min-h-screen p-4 sm:pt-8">
      <h1 className="text-3xl sm:text-4xl font-bold text-textPrimary mb-8 sm:mb-10 text-center">Nuestra Tienda</h1>
      <div className="container mx-auto px-4 sm:px-6 mb-6 sm:mb-8 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0 md:space-x-6">
        <input
          type="text"
          placeholder="Buscar productos..."
          className="w-full md:flex-grow px-4 sm:px-5 py-2 sm:py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary transition-all"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
<select

  className="w-full md:w-auto px-4 sm:px-5 py-2 sm:py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary transition-all bg-card"
  value={selectedCategory}
  onChange={(e) => setSelectedCategory(e.target.value)}
>
  {categories.map((category) => (
    <option key={category.id} value={category.name}>
      {category.name}
    </option>
  ))}
</select>

      </div>
      <ShopProductGrid products={filteredProducts} onAddToCart={onAddToCart} onViewDetail={handleViewDetail} />

      <ProductDetailModal
        product={selectedProduct}
        isOpen={isDetailModalOpen}
        onClose={handleCloseDetailModal}
        onAddToCart={onAddToCart}
      />
    </div>
  );
};

export default ShopPage;
